<template>
  <div class="mb-[24px]">
    <div class="pb-[10px] flex items-center justify-between border-0 border-b border-solid border-grey-light min-h-[50px]">
      <div class="flex items-center gap-3">
        <p @click="titleURL && backToParent()" :class="`font-medium sm:text-[28px] text-[22px] text-black leading-none capitalize ${titleURL && 'cursor-pointer'}`">{{ title }}</p>
        <div v-if="breadcrumb.length" class="md:flex hidden items-center">
          <div v-for="(crumb, index) in breadcrumb" :key="index" class="flex items-center">
            <shipblu-icon iconLibrary="material" :iconName="$i18n.locale === 'en' ? 'chevron_right' : 'chevron_left'" iconClass="mx-[4px] text-[16px] text-exclusive-plum" />
            <span :class="`text-[14px] leading-[20px] ${crumb.url ? 'text-exclusive-plum' : 'text-damp-basement'}`">{{ crumb.name }}</span>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
    <div v-if="breadcrumb.length" class="mt-4 md:hidden flex items-center">
      <div v-for="(crumb, index) in breadcrumb" :key="index" class="flex items-center">
        <shipblu-icon v-if="index !== 0" iconLibrary="material" :iconName="$i18n.locale === 'en' ? 'chevron_right' : 'chevron_left'" iconClass="mx-[4px] text-[16px] text-exclusive-plum" />
        <span :class="`text-[14px] leading-[20px] ${crumb.url ? 'text-exclusive-plum hover:text-primary' : 'text-damp-basement'}`">{{ crumb.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-header',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleURL: {
      type: String,
      default: ''
    },
    breadcrumb: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    backToParent () {
      this.$router.push({ path: `/${this.$i18n.locale}/${this.titleURL}` })
    }
  }
}
</script>